import {reduxLib} from 'lib.front';

const {logIn, logOut, logVerificar} = reduxLib.auth.actions;
const {loadingModal} = reduxLib.loading.actions;
const {closeModal, openModal} = reduxLib.modal.actions;
const {closeMsg, openMsg} = reduxLib.msg.actions;
const {closeOverlay, openOverlay} = reduxLib.overlay.actions;
const {closeSidebar, openSidebar} = reduxLib.sidebar.actions;

export {
   logIn,
   logOut,
   logVerificar,
   loadingModal,
   closeModal,
   openModal,
   closeMsg,
   openMsg,
   closeOverlay,
   openOverlay,
   closeSidebar,
   openSidebar
};
